import { t } from "i18next";
import Select from "react-select";

const SelectBox = ({
  options,
  val,
  name,
  change,
  isLoading = false,
  isMulti = false,
}) => {
  return (
    <Select
      className='basic-single'
      classNamePrefix='select'
      isClearable={true}
      isLoading={isLoading}
      name={name} // IMPORTANT: use actual name
      isMulti={isMulti}
      value={
        isMulti
          ? options?.filter((o) => val?.includes(o.value)) // MULTI
          : options?.find((o) => o.value === val) || null // SINGLE
      }
      options={options}
      placeholder={` ${t("please")} ${t("select")}`}
      onChange={(e) =>
        e === null
          ? change(name, isMulti ? [] : "")
          : change(name, isMulti ? e.map((x) => x.value) : e.value)
      }
    />
  );
};

export default SelectBox;
